<template>
  <div class="hamburger" :class="{ 'hamburger-active': isOpen }" />
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.hamburger {
  width: 19px;
  height: 2px;
  background-color: $default-text-color;
  border-radius: 2px;
  position: relative;
  z-index: 99;

  &:before,
  &:after {
    content: "";
    position: absolute;
    width: 19px;
    height: 2px;
    border-radius: 2px;
    background: $default-text-color;
    transition: 0.3s;
  }
  &:before {
    top: -6px;
    left: 0;
  }
  &:after {
    top: 6px;
    left: 0;
  }

  &-active {
    background: transparent;
    &:before {
      top: 0;
      transform: rotate(45deg);
    }
    &:after {
      top: 0;
      transform: rotate(135deg);
    }
  }
}
</style>
